import { Typography } from '@material-ui/core';
import Button from 'components/Button';
import Modal from 'components/Modal';
import { capacityTypeDomain } from 'models';
import React, { ReactNode } from 'react';

interface CapacityTypeInUseModalProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

export default function CapacityTypeInUseModal({
  open,
  onClose,
  children
}: CapacityTypeInUseModalProps) {
  return (
    <Modal
      open={open}
      testId="capacityTypeInUse"
      title={`${capacityTypeDomain.label} in use`}
      modalActions={
        <Button
          color="primary"
          size="medium"
          onClick={onClose}
          data-testid="capacityTypeInUseModalCloseButton"
        >
          Close
        </Button>
      }
      onClose={onClose}
    >
      <Typography data-testid="capacityTypeInUseModalText">
        {children}
      </Typography>
    </Modal>
  );
}
